// extracted by mini-css-extract-plugin
export var alignLeft = "teaser-module--align-left--78aed";
export var alignRight = "teaser-module--align-right--c280d";
export var button = "teaser-module--button--d1f12";
export var cover = "teaser-module--cover--803c4";
export var dark = "teaser-module--dark--a0515";
export var h5 = "teaser-module--h5--4842d";
export var imageWrapper = "teaser-module--image-wrapper--39a59";
export var inner = "teaser-module--inner--2a160";
export var innerWithImage = "teaser-module--inner-with-image--7bdb0";
export var light = "teaser-module--light--29ddf";
export var medium = "teaser-module--medium--1541c";
export var teaser = "teaser-module--teaser--dd48d";